import {
	PATIENT_NOTES_LIST_REQUEST,
	PATIENT_NOTES_LIST_SUCCESS,
	PATIENT_NOTES_LIST_FAILURE
} from "../../../constants";

const initialState = {
	loading: false,
	data: null,
	error: null,
	type: null,
};

const patientNotesListReducer = (state = initialState, action) => {
	switch (action.type) {
		case PATIENT_NOTES_LIST_REQUEST:
			return {
				...state,
				loading: true,
				error: null,
				data: null,
				type: action.types,
			};
		case PATIENT_NOTES_LIST_SUCCESS:
			return {
				...state,
				loading: false,
				data: action.payload,
				error: null,
				type: action.types,
			}
		case PATIENT_NOTES_LIST_FAILURE:
			return {
				...state,
				loading: false,
				error: action.payload,
				data: null,
				type: action.types,
			}
		default:
			return state;
	}
}
export default patientNotesListReducer